import { useLayoutEffect, useRef } from 'react';
import style from './Main.module.scss';
import { Fade } from 'react-reveal';
import TextAnim from '../../../../components/TextAnim';
import { useIntersectionObserver, useMediaQuery } from 'usehooks-ts';

const MainSection = () => {
  const blockRef = useRef(null);
  const isMobile = useMediaQuery('(max-width:767px)');

  const ref = useRef(null);
  const entry = useIntersectionObserver(ref, {});
  const isVisible = !!entry?.isIntersecting;

  return (
    <main ref={ref} className={style.main}>
      <div className='container'>
        <div ref={blockRef} className={style.mainBody}>
          <Fade spy={isVisible}>
            <div className={style.mainBody__title}>
              {isMobile ? (
                <>
                  An <br /> innovative <br />{' '}
                  <span>
                    digital <br /> assets
                  </span>{' '}
                  and <br />
                  <span>algorithmic trading firm</span>
                </>
              ) : (
                <>
                  An innovative <br /> <span>digital assets</span> and <br />
                  <span>algorithmic trading firm</span>
                </>
              )}
            </div>
          </Fade>
          <Fade spy={isVisible}>
            <div className={style.mainBody__subtitle}>
              Great minds, working together worldwide
            </div>
          </Fade>
        </div>
      </div>
    </main>
  );
};

export default MainSection;
